import { useEffect, useState } from 'react';

export type DeviceType = 'Android' | 'iOS' | 'Desktop';

export const useDevice = (): DeviceType | null => {
    const [device, setDevice] = useState<DeviceType | null>(null);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const ua = window.navigator.userAgent.toLowerCase();

        const isAndroid = ua.includes('android');
        const isIOS =
            ua.includes('iphone') ||
            ua.includes('ipod') ||
            ua.includes('ipad') ||
            // Detect iPadOS 13+ which reports as Mac
            (ua.includes('macintosh') && window.navigator.maxTouchPoints > 1);

        if (isAndroid) {
            setDevice('Android');
        } else if (isIOS) {
            setDevice('iOS');
        } else {
            setDevice('Desktop');
        }
    }, []);

    return device;
};
